export const ru = {
    'period-from-to': '{from}–{to}'
};
